
<!-- MAKE SURE TO ADD data-bs-dismiss="modal" IN THE BUTTONS SLOT IF THEY NEED TO CLOSE THE MODAL-->
<!-- THIS REALLY IS JUST TAKING DEANS MODAL AND REPLACING IT TO A WRAPPER OF BOOTSTRAP FROM UNIVERSAL THEME -->



<template>
      <div class="modal fade" :id="'modal_'+_uid">
        <div class="modal-dialog" :style="customWidth ? {width:customWidth+'px', maxWidth:customWidth+'px'} : {}" :class="{'modal-lg':large, 'modal-xl':xlarge,'modal-dialog-centered':center,'swal2-show':center}">
          <div class="modal-content">
            <div class="modal-header"  v-if="!hideHeader">
              <h5 class="modal-title" v-if="!icon && !subtitle">
{{ title }}
              </h5>
              <!-- a header with an icon badge and a line under the title (the יומן modal) -->
              <div class="modalTitleBlock" v-else>
                <span class="modalIconBadge" v-if="icon"><i :class="icon"></i></span>
                <div>
                  <h5 class="modal-title">{{ title }}</h5>
                  <div class="modalSubtitle" v-if="subtitle">{{ subtitle }}</div>
                </div>
              </div>
              <button type="button" class="btn-close" data-bs-dismiss="modal" v-if="!noClose">
                <span></span>
              </button>
            </div>
            <div class="modal-body" style="text-align: right;">
              <slot name="body"></slot>
            </div>
            <div class="modal-footer" v-if="!hideFooter">
              <slot name="buttons"></slot>
            </div>
          </div>
        </div>
      </div>
</template>

<script>

export default {
  name: "Modal",

  props: ['title','subtitle','icon','large','hideFooter','hideHeader','xlarge','center','noClose','customWidth'],
  data() {
    return {
      modalElement: null,
    }
  },
  mounted() {


    if (this.noClose) {

      this.modal = new bootstrap.Modal(document.getElementById('modal_'+this._uid),{backdrop: 'static', keyboard: false});

    } else {

      this.modal = new bootstrap.Modal(document.getElementById('modal_'+this._uid));

    }

    
  },
  methods: {

    hide() {
      document.activeElement.blur();
      this.modal.hide();
    },
    show() {
      this.modal.show();
    },

  },
};
</script>
<style>
.modalTitleBlock {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.modalTitleBlock .modal-title {
  margin: 0;
}

.modalIconBadge {
  flex: 0 0 44px;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #efeafc;
  color: #6d5bd0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.modalSubtitle {
  margin-top: 2px;
  font-size: 13px;
  color: #64748b;
}
</style>
